<template>
  <div :data-testid="getTestId('admin-panel-products-page')">
    <PanelProductCrudTable :data-testid="getTestId('admin-panel-products-table')" />
  </div>
</template>

<script>
import { getTestId } from '@/utils/testUtils';

export default {
  name: 'PanelProducts',
  components: {
    PanelProductCrudTable: () => import('../../components/table/PanelProductCrudTable.vue')
  },
  methods: {
    getTestId(testId) {
      return getTestId(testId);
    }
  }
};
</script>

<style scoped>
/* 필요한 스타일이 있다면 여기에 추가 */
</style>
